module.exports = (__webpack_require__(11))(65);


//////////////////
// WEBPACK FOOTER
// delegated ../../node_modules/whatwg-fetch/fetch.js from dll-reference vendor_lib
// module id = 256
// module chunks = 0